var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBody prh-main bg-grey-light w-100"},[_c('little-header'),_c('div',{staticClass:"lec-header"}),_c('little-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }